<script>
import DialogBase from "../../dialog/components/dialog-base.vue";
import DialogHeader from "../../dialog/components/dialog-header.vue";
import DialogBody from "../../dialog/components/dialog-body.vue";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
import UserWizard from "./user-wizard.vue";
import {
    translations
} from "./data/variables";

export default {
    name: "user-wizard-dialog",
    computed: {
        translations() {
            return translations
        }
    },
    components: {UserWizard, DialogActionbar, DialogBody, DialogHeader, DialogBase},
    data() {
        return {
            showDialog: false,
            addMode: false,
            id: null
        }
    },
    methods: {
        show() { this.showDialog = true; },
        hide() { this.showDialog = false; },
        handleCancel() { this.hide(); },
    },
    mounted: function () {
        EaseEventBus.listen('userAdd', () => {
            this.addMode = true;
            this.show();
        });
        EaseEventBus.listen('userEdit', params => {
            this.addMode = false;
            this.id = params.id;
            this.show();
        });
    }
}
</script>

<template>
    <dialog-base
        persistent
        :showDialog="showDialog"
    >
        <dialog-header
            persistent
            :title="addMode ? translations.addNewUser : translations.editUser"
            :subTitle="addMode ? translations.completeSteps : null"
        />
        <dialog-body>
            <user-wizard
                :show="showDialog"
                :addMode="addMode"
                :id="id"
                @close="handleCancel"
            />
        </dialog-body>
    </dialog-base>
</template>

<style scoped>

</style>
